/**
 * Created by DejanK on 1/8/2017.
 */

export default RbAnchorScrollService;

RbAnchorScrollService.$inject = ['$location', '$anchorScroll', '$timeout'];
function RbAnchorScrollService($location, $anchorScroll, $timeout){
  const $service = this;

  $service.scroll = (hashId) => {
    $timeout(()=>{
      $location.hash(hashId);
      $anchorScroll();
    });
  }
}
